import "./sesionCard.css";
import { formatearFechaHora } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

export default function SesionCard({ sesion, abierta, onToggle }) {
  return (
    <div className="factura-card" onClick={onToggle}>
      {/* ================= RESUMEN ================= */}
      <div className="factura-row">
        <div className="factura-info">
          <span>
            <strong>Sesión #{sesion.idSesion}</strong>{" "}
            {formatearFechaHora(sesion.fechaApertura)}
          </span>
          <span>Punto: {sesion.punto}</span>
          <span className={`estado estado-${sesion.estado}`}>
            {sesion.estado}
          </span>
        </div>
      </div>

      {/* ================= DETALLE ================= */}
      {abierta && (
        <div className="factura-detalle">
          <div className="factura-total">
            <div>Saldo inicial:  { formatearPrecio(sesion.saldoInicial)}</div>
            <div>Saldo final: {formatearPrecio(sesion.saldoFinal ?? 0)}</div>
          </div>
          <div>
            <strong>Cierre:</strong>{" "}
              {formatearFechaHora(sesion.fechaCierre)}
          
          </div>
          <div>
            <strong>Usuario apertura:</strong> {sesion.usuarioAperturaId}
          </div>
          <div>
            <strong>Usuario cierre:</strong>{" "}
            {sesion.usuarioCierreId ?? "-"}
          </div>
          <div>
            <strong>Observaciones:</strong> {sesion.observaciones ?? "-"}
          </div>
        </div>
      )}
    </div>
  );
}